import React from 'react';

const AboutPage = () => {
  return (
    <div className="bg-amber-400 m-4 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl font-semibold mb-4">About Netsi't Kitchen</h1>
          <img
            src="/373290171_341255784924501_1770368403672450218_n.jpg" // Replace with an image of the chef
            alt="Chef"
            className="w-full h-auto rounded-lg shadow-lg mb-8"
          />
          <p className="text-gray-700 text-lg">
            Meet Netsanet, a remarkable woman who has transformed her life through
            passion, resilience, and the art of cooking. Her journey from adversity to success
            is nothing short of inspiring.
          </p>
          <p className="text-gray-700 mt-4 text-lg">
            Born and raised in Addis Ababa, Netsi's faced numerous challenges and
            hardships throughout her life. Despite the odds stacked against her, she
            persevered, finding solace and joy in the kitchen.
          </p>
          <p className="text-gray-700 mt-4 text-lg">
            Cooking became her refuge, a creative outlet where she could channel her energy
            and emotions into crafting delectable dishes that told stories of resilience,
            hope, and the flavors of her heritage.
          </p>
          <p className="text-gray-700 mt-4 text-lg">
            Netsanet specializes in authentic Ethiopian cuisine, a culinary tradition
            passed down through generations. Her dedication to preserving and sharing these
            traditional flavors has earned her a reputation as a culinary virtuoso.
          </p>
          <p className="text-gray-700 mt-4 text-lg">
            Today, she's the heart and soul behind Netsi's Kitchen, where she brings
            her unique blend of flavors to life. Whether it's an intimate gathering, a grand
            celebration, or a pop-up event, Netsanet and her team curate unforgettable
            dining experiences that leave a lasting impression.
          </p>
          <p className="text-gray-700 mt-4 text-lg">
            Netsanet believes that food has the power to heal, inspire, and unite people.
            She is not just a chef; she's a symbol of resilience, a testament to the
            extraordinary heights one can reach through determination and a love for cooking.
          </p>
          <p className="text-gray-700 mt-4 text-lg">
            Join us on this culinary journey with Netsi's as she continues to create
            culinary masterpieces and inspire us all with her incredible story.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
